// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"53004f98","504":"d6776035","877":"d6776035"}[chunkId] + ".chunk.css";
};